import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useDeleteFarmer = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ farmerId }: { farmerId: number }) => {
      return fetch(`${API}/api/semeadora/farmers/${farmerId}/`, {
        method: "DELETE",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["farmers"] });
    },
    onError: (error) => {
      console.error("Erro ao remover agricultora", error);
    },
  });
};

export default useDeleteFarmer;
